import * as React from 'react';
import styled from '@emotion/styled';
import { COLOR, FONT_WEIGHT } from '@ordermentum/ui-constants';
import Icon from '../Icon';

const ErrorWrapper = styled('div')`
  display: flex;
  font-size: 0.75rem;
  margin-top: 0.33rem;
`;

const ErrorIcon = styled('div')`
  margin-right: 0.25rem;
`;

const ErrorLabel = styled('span')`
  color: ${COLOR.RED_500};
  font-style: italic;
  font-weight: ${FONT_WEIGHT.NORMAL};
  margin-right: 0.25rem;
`;

const ErrorBody = styled('div')`
  margin-top: 4px;
`;

const Error = ({ error }: { error: string | string[] }) => (
  <ErrorWrapper data-test-id="error-wrapper">
    <ErrorIcon>
      <Icon name="error" color="red" />
    </ErrorIcon>
    <ErrorBody data-test-id="error-body">
      <ErrorLabel>Error:</ErrorLabel>{' '}
      {Array.isArray(error) ? error.join(', ') : error}
    </ErrorBody>
  </ErrorWrapper>
);

export default Error;
